import { RootState } from "@/services/store/root-state";
import { IMatchingSearchState } from "./matching-search.types";
import { GetterTree } from "vuex";

export const getters: GetterTree<IMatchingSearchState, RootState> = {};
